import { Text } from 'components/ToolkitV2/Text/Text';
import { Spacer } from 'helpers/genericStyles';
import { ProgressBar } from 'components/ToolkitV2/ProgressBar/ProgressBar';

import * as Styled from './LoadingScreen.styled';

import { ARTIFICIAL_LOADING_TIME_LENGTH_IN_MILLISECONDS } from '../../../../CarValuationTool.constants';

const LoadingScreen = () => {
  return (
    <Styled.Container>
      <Text size="L18" weight="semibold" color="GREY_DARK">
        Comparing your car to similar listings...
      </Text>
      <Spacer marginBottom="S8" />
      <ProgressBar
        animationDurationInMilliseconds={
          ARTIFICIAL_LOADING_TIME_LENGTH_IN_MILLISECONDS
        }
      />
    </Styled.Container>
  );
};

export { LoadingScreen };
